// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"NewVerificationFlow_outerContainer__3V29K","buttonContainer":"NewVerificationFlow_buttonContainer__lirdD"};